export default __webpack_public_path__ + "static/media/rnr-sports-table-13-cn.38c63575.webp";